/**
 * Remote Config Keys Constants
 * Only for kebab menu configKey values (hardcoded strings in menu items)
 *
 * For accessing config via useSelector, use direct dot notation:
 * ✅ state.remoteConfig.switches.myAccount
 * ✅ state.remoteConfig.switches.offers?.plpRedirectionEnabled
 * ✅ state.remoteConfig.switches.kebabMenu
 */

// Kebab Menu item configKey values (used as strings in menu items)
export const KEBAB_MENU_KEYS = {
  NEED_HELP_ENABLED: 'needHelpEnabled',
  AUTHENTICITY_ENABLED: 'authenticityEnabled',
  CSR_ENABLED: 'csrEnabled',
  RESPONSIBLE_DISCLOSURE_ENABLED: 'responsibleDisclosureEnabled',
  MY_ORDERS_ENABLED: 'myOrdersEnabled',
  PRIVE_ENABLED: 'priveEnabled',
  WALLET_ENABLED: 'walletEnabled',
  SUBSCRIPTION_ENABLED: 'subscriptionEnabled',
  MY_PROFILE_ENABLED: 'myProfileEnabled',
  MY_WISHLIST_ENABLED: 'myWishlistEnabled',
  REVIEWS_ENABLED: 'reviewsEnabled',
  VIDEO_CONSULTATION_ENABLED: 'videoConsultationEnabled',
  HELP_CENTER_ENABLED: 'helpCenterEnabled',
} as const;
